
var backend =
{
	main_url : process.env.VUE_APP_MAIN_URL,
	callback_url : process.env.VUE_APP_CALLBACK_URL,
	file_port : process.env.VUE_APP_FILE_PORT,
}

var version = process.env.VUE_APP_VERSION
var is_test = true

export default
{
	backend,
	version,
	is_test,
}

